// 订单记录
import orderRecord from './children/orderRecord'
// 返修配置
import repairConfig from './children/repairConfig'
// 返修记录
import repairRecord from './children/repairRecord'
// 财务管理
import finance from './children/finance'
// 仓库管理
import warehouse from './children/warehouse'
// SN
import SN from './children/sn'
// 知识库
import knowledge from './children/knowledge'
// 系统管理
import system from './children/system'
// 工具管理
import tools from './children/tools'
import user from './children/user'
// 异常件记录
import abnormal from './children/abnormal'
// 统计
import { statistic } from './children/statistics'
// 短信报修
import requestSms from './children/requestSms'

let sider = [
  {
    path: '/',
    name: 'home',
    meta: { tag: '首页' },
    component: () => import('@/pages/Home')
  }
]

export default [
  ...orderRecord,
  ...repairConfig,
  ...repairRecord,
  ...abnormal,
  ...statistic,
  ...requestSms,
  ...finance,
  ...system,
  ...warehouse,
  ...SN,
  ...knowledge,
  ...sider,
  ...tools,
  ...user
]
